import { Box, Container } from "@mui/material";
import { ReactNode } from "react";

interface PageLayoutDesktopProps {
  header?: ReactNode;
  content: ReactNode;
  footer?: ReactNode;
  maxWidth?: number;
}

/**
 * Desktop page layout component.
 *
 * Provides consistent page structure with optional header/footer and
 * constrained content width for optimal readability.
 */
export function PageLayoutDesktop({
  header,
  content,
  footer,
  maxWidth = 1152,
}: PageLayoutDesktopProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {header && (
        <Box sx={{ mb: 3 }}>
          <Container maxWidth={false} sx={{ maxWidth }}>
            {header}
          </Container>
        </Box>
      )}

      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <Container maxWidth={false} sx={{ maxWidth }}>
          {content}
        </Container>
      </Box>

      {footer && (
        <Box sx={{ mt: 3 }}>
          <Container maxWidth={false} sx={{ maxWidth }}>
            {footer}
          </Container>
        </Box>
      )}
    </Box>
  );
}
